import { useQuery } from 'react-query';

import { getCardClusterFilter as queryFn } from 'api/endPoints/getCardClusterFilter';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCardClusterFilter = (params: QueryParams) => {
    return useQuery<ICardCluster[], QueryError, ICardCluster[], [QueryKeys, unknown]>({
        queryKey: ['getCardClusterFilter', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}

export interface ICardCluster {
    value: number;
    label: string;
}
